import React, { useContext, useMemo } from 'react'
import { getValue } from 'firebase-utils'
import NumberCampaignStep from './steps/NumberCampaignStep'
import NumberSelectStep from './steps/NumberSelectStep'

import StepWizard from '../shared/StepWizardClone/WizardClone'
import { getErrorMessage } from '../../utils/helpers'
import { ScreenSizeContext } from 'providers'
import { CampaignContext } from '../../contexts/CampaignContext'
import { useHistory, useLocation } from 'react-router-dom'
import { SmsNumberCampaignContext } from '../../contexts/SmsNumberCampaignContext'

type PropsType = {
    item: Record<string, unknown>
    onSubmit(v): unknown,
}

const Wizard = ({
    item,
    onSubmit,
    ...props
}: PropsType): JSX.Element => {
    const history = useHistory()
    const { pathname } = useLocation()
    const appPath = '/number-assignement'
    const basePath = `${pathname.split(appPath)[0]}`

    const {
        numberNetworkError,
        setNumberNetworkError
    } = useContext(SmsNumberCampaignContext)
    const screenSize = useContext(ScreenSizeContext)

    const { acceptedCampaigns } = useContext(CampaignContext)

    const error = useMemo(() => numberNetworkError ? getErrorMessage(numberNetworkError) : null, [numberNetworkError])

    const steps = useMemo(() => {
        return [
            {
                id: 'campaign_step',
                label: getValue('sms_enrollment_number_assignment_step_1'),
                secondaryLabel: getValue('sms_enrollment_number_step_1_secondaryLabel'),
                title: getValue('sms_enrollment_number_step_1_title'),
                customBackButtonActionOnFirstStep: () => history.push(basePath),
                component: NumberCampaignStep,
                additionalProps: {
                    eligibleCampaigns: acceptedCampaigns.filter((campaign) => !campaign.deleted_at)
                }
            },
            {
                id: 'number_step',
                label: getValue('sms_enrollment_number_assignment_step_2'),
                secondaryLabel: getValue('sms_enrollment_number_step_2_secondaryLabel'),
                title: getValue('sms_enrollment_number_step_2_title'),
                component: NumberSelectStep
            }
        ]
    }, [item])

    return <StepWizard
        steps={steps}
        onSubmit={onSubmit}
        error={error}
        onCloseError={setNumberNetworkError}
        enableBackButtonOnFirstStep
        smallView={screenSize.mobile}
        {...props}
    />
}

export default Wizard
